import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton } from './radio-button';

/**
 * @description Radio group component
 * props: options: array of objects of shape { name: string, value: string }
 */

const RadioGroup = ({
    id,
    options,
    checked,
    handleOnChange,
    className,
    radioButtonClassName
}) => {
    return (
        <div className={className}>
            {options.map(option => (
                <RadioButton
                    key={option.value}
                    id={id}
                    value={option.value}
                    checked={checked}
                    handleOnChange={handleOnChange}
                    radioButtonClassName={radioButtonClassName}>
                    {option.name}
                </RadioButton>
            ))}
        </div>
    );
};

RadioGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.string
        })
    ),
    checked: PropTypes.string,
    handleOnChange: PropTypes.func,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    radioButtonClassName: PropTypes.string
};

RadioGroup.defaultProps = {
    className: '',
    radioButtonClassName: ''
};

export default RadioGroup;
